import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAccessRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-access',
	path: '/jira/servicedesk/projects/:projectKey/settings/access',
	exact: true,
};
